import { z } from 'zod';

export const FormSchema = z.object({
  ngay_hl: z.string(),
  ty_gia: z.coerce.number().min(0.01, 'Tỷ giá phải lớn hơn 0')
});

export type FormValues = z.infer<typeof FormSchema>;

export const initialFormValues: FormValues = {
  ngay_hl: new Date().toISOString(),
  ty_gia: 1
};
